import { Button } from '@mui/material';
import FormProvider from '@Components/hook-form';

import { AtLocator } from '@Components/shared/locators/AtLocator';

import { CreateDialogFooterLayout } from '@Components/shared/layouts/CreateDialogFooterLayout';
import { CreateDialogLayout } from '@Components/shared/layouts/CreateDialogLayout';

import { CreateCampaignContent } from './CreateCampaignContent';
import { useCreateCampaign } from '@Modal/hooks/campaigns/useCreateCampaign';
import { useCreateCampaignForm } from '@Forms/campaign/CreateCampaignFormContext';

export const CreateCampaignForm = () => {
  const methods = useCreateCampaignForm();
  const { handleCreateCancel, submittable, handleSubmitCreateCampaign } = useCreateCampaign();

  return (
    <FormProvider methods={methods}>
      <CreateDialogLayout>
        <CreateCampaignContent />
        <CreateDialogFooterLayout>
          <AtLocator type="button" name="Cancel">
            <Button variant="outlined" color="inherit" onClick={handleCreateCancel}>
              Cancel
            </Button>
          </AtLocator>
          <AtLocator type="button" name="Submit">
            <Button
              type="submit"
              variant="contained"
              disabled={!submittable}
              onClick={handleSubmitCreateCampaign}
            >
              Confirm
            </Button>
          </AtLocator>
        </CreateDialogFooterLayout>
      </CreateDialogLayout>
    </FormProvider>
  );
};
